import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { orderBy, has, set, split, get } from 'lodash/fp';
import { Table } from 'rsuite';
import Pagination from '../../Pagination';
import {
  ActionCell,
  TagsCell,
  LinkCell,
  ImageLinkCell,
  OnHoldQtyCell
} from './CustomCells';
import WeightCell from '../../widgets/custom-cell/Weight';
import PathKeyCell from '../../widgets/custom-cell/PathKey';
import DateCell from '../../widgets/custom-cell/Date';
import {
  ItemType,
  PackageType
} from '../../../constants/inventory/InventoryTypes';
import PaginationType from '../../../interfaces/PaginationType';
import CustomHeaderCell from '../../widgets/custom-cell/HeaderCell';
import AutoHeightTable from '../../AutoHeightTable';
import OnHoldReservationsModal from '../OnHoldReservationsModal';

const { Column, HeaderCell, Cell } = Table;

class InventoryAvailabilityList extends Component {
  constructor(props) {
    super(props);
    this.state = { isInit: false, selectedAvailability: null };
  }

  componentDidMount() {
    const { isInit } = this.state;
    const { onInit, query } = this.props;
    if (!isInit) {
      this.setState({ isInit: true }, () => onInit(query));
    }
  }

  getData() {
    const { items } = this.props;
    const { sortColumn, sortType } = this.state;
    return orderBy(sortColumn, sortType, items);
  }

  handleSortColumn = (sortColumn, sortType) => {
    const { onSort, query } = this.props;
    onSort(sortColumn, sortType, query);
  };

  onItemSaved = () => {
    this.handleCloseCreateModal();
  };

  handleChangePage = page => {
    const { onChangePage, loadedPages, query } = this.props;
    const isPageLoaded = has(page, loadedPages);
    const nextPageQuery = set('page', page, query);
    onChangePage(nextPageQuery, isPageLoaded);
  };

  handleChangeLimit = limit => {
    const { onChangeLimit, query } = this.props;
    const newQuery = { ...query, limit, page: 1 };
    onChangeLimit(newQuery);
  };

  handleViewOnHoldReservations = rowData => {
    this.setState({ selectedAvailability: rowData });
  };

  handleCloseOnHoldReservations = () => {
    this.setState({ selectedAvailability: null });
  };

  handleOnHoldReservationCanceled = () => {
    const { onInit, query } = this.props;
    onInit(query);
  };

  renderPagination() {
    const { pagination } = this.props;
    return (
      <Pagination
        page={pagination.currentPage}
        limit={pagination.limit}
        total={pagination.totalCount}
        onChangePage={this.handleChangePage}
        onChangeLimit={this.handleChangeLimit}
      />
    );
  }

  render() {
    const { type, isFetching, query } = this.props;
    const { selectedAvailability } = this.state;
    const [sortColumn, sortType] = split(':', get('order', query));
    return (
      <div>
        <AutoHeightTable
          reduceHeight={540}
          loading={isFetching}
          data={this.getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={this.handleSortColumn}
          bordered
        >
          <Column width={70} align="center">
            <CustomHeaderCell>Photo</CustomHeaderCell>
            <ImageLinkCell dataKey="item.photo" type={type} />
          </Column>
          <Column width={150} sortable resizable>
            <CustomHeaderCell>Name</CustomHeaderCell>
            <LinkCell dataKey="item.name" type={type} />
          </Column>
          <Column width={250} resizable>
            <CustomHeaderCell>Description</CustomHeaderCell>
            <PathKeyCell dataKey="item.description" />
          </Column>
          <Column width={100} sortable resizable>
            <CustomHeaderCell>Location</CustomHeaderCell>
            <PathKeyCell dataKey="location.name" />
          </Column>
          {ItemType === type && (
            <Column width={100} sortable resizable>
              <CustomHeaderCell>Zone</CustomHeaderCell>
              <PathKeyCell dataKey="zone.name" />
            </Column>
          )}
          <Column width={55} sortable align="right">
            <CustomHeaderCell>Qty</CustomHeaderCell>
            <Cell dataKey="quantity" />
          </Column>
          <Column width={100} sortable align="right">
            <CustomHeaderCell>Onhold Qty</CustomHeaderCell>
            <OnHoldQtyCell
              dataKey="onholdQuantity"
              onView={this.handleViewOnHoldReservations}
            />
          </Column>
          <Column width={65} sortable align="right">
            <CustomHeaderCell>Price</CustomHeaderCell>
            <Cell dataKey="price" />
          </Column>
          <Column width={95} sortable align="right">
            <CustomHeaderCell>Weight (lb)</CustomHeaderCell>
            <WeightCell dataKey="weight" />
          </Column>
          <Column width={150} resizable>
            <CustomHeaderCell>Tags</CustomHeaderCell>
            <TagsCell dataKey="tags" />
          </Column>
          <Column width={120} sortable>
            <CustomHeaderCell>Last Updated</CustomHeaderCell>
            <DateCell dataKey="lastUpdated" />
          </Column>
          <Column width={150} align="center">
            <HeaderCell>Action</HeaderCell>
            <ActionCell dataKey="item.id" type={type} />
          </Column>
        </AutoHeightTable>
        {this.renderPagination()}
        <OnHoldReservationsModal
          show={!!selectedAvailability}
          type={type}
          availability={selectedAvailability}
          onHide={this.handleCloseOnHoldReservations}
          onCanceled={this.handleOnHoldReservationCanceled}
        />
      </div>
    );
  }
}

InventoryAvailabilityList.propTypes = {
  type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  query: PropTypes.shape({}).isRequired,
  loadedPages: PropTypes.shape({}).isRequired,
  pagination: PaginationType.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired
};

export default InventoryAvailabilityList;
